import React, { useState, useEffect } from 'react'
import Table from './Table'
import { useNavigate, useLocation } from 'react-router-dom';
// import Routes from '../../../../../../../layouts/Routes'
import { LenderGetAllLeadsApi, LenderGetAllLeadsCountApi, SaveLenderComments, assignLenderApi, assignEmployee, assignMultipleLenders, getAsssignedLenderList, assignLenderEmployee, getLenderEmployee, deleteLeadAdmin, getLendersCountApi, getLenderApi, getUserCountApi, getUsersApi, getWorkflowApi } from '../../CommunityActionCreator'
import Loader from '../../../../../../presentationals/Loader/Loader.component'
import DeletePopup from '../../deletePopup'
import AssigmentUi from './assigmentPopup'
import Alerts from '../../../Popups/SidePopup'
import { sortingFunction } from '../../../CommonUtils';
import { LICENCE_ID } from '../../../api-factory';
import EmpAssignmentPopup from './EmpAssignmentPopup'
import moment from 'moment'
import {
    completeLoanTypeArr
} from '../../../CommonUtils'
import ViewLeadsInfoPopup from './ViewLeadsInfoPopup';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import { paginationFuction } from '../../../CommonUtils';
import CustomDeletePopup from '../../../Popups/CustomDeletePopup';

// let rolesData = window.sessionStorage.getItem('rolesData');

let filterData = [
    { code: 'community', name: 'Community' },
    { code: 'b2c', name: 'B2C' }

]
const UiComponent = ({ communityId, qrId, handlePage,leadPageHandler }) => {
    const [searchInput, setSearchInput] = useState('')
    const navigate = useNavigate();
    const location = useLocation();
    const [allData, setAllData] = useState([])
    const [loaderState, setLoaderState] = useState(false)
    const [deletePopupState, setDeletePopupState] = useState(false)
    const [deleteLeadPopupState, setDeleteLeadPopupState] = useState(false)
    const [idForDelete, setIdForDelete] = useState('')
    const [totalCount, setTotalCount] = useState(0)
    const [pageNumber, setPageNumber] = useState(1)
    const [noOfRows, setNoOfRows] = useState(10)
    const [comment, setComment] = useState('');
    const [commentId, setCommentId] = useState('');
    const [assignmentPopup, setassignmentPopup] = useState(false)
    const [lenderData, setAllLenders] = useState()
    const [empData, setEmpData] = useState()
    const [lenderEmpData, setLenderEmpdata] = useState()

    const [loanIdToDelete, setLoanIdToDelete] = useState('')
    const [userIdToDelete, setUserIdToDelete] = useState('')

    const [loanId, setLoanId] = useState()

    const [lenderIdList, setlenderIdList] = useState([])
    const [empId, setEmpId] = useState()
    const [lenderEmpId, setLenderEmpId] = useState()

    const [alertPopup, setalertPopup] = useState(false)
    const [msg, setmsg] = useState(false)
    const [phoneNo, setPhoneNo] = useState('')
    const [emailId, setemailId] = useState('')
    const [commentValueToShow, setcommentValueToShow] = useState('')
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [trigger, setTrigger] = useState(false)
    const [leadType, setLeadType] = useState('')
    const [applyDate, setapplyDate] = useState('')
    const [loanType, setloanType] = useState('')
    const [viewPopupState, setViewPopupState] = useState('')
    const [empAssignPopup, setEmpAssignPopup] = useState('')
    const [lenderEmpAssignPopup, setLenderEmpAssignPopup] = useState(false)

    const [data, setData] = useState('')
    const [allowedClick, setAllowedTotalClicks] = useState('')
    const [clicked, setClicked] = useState(0)
    const [disable, disableButton] = useState(false)
    const [search, setSearch] = useState('mobile')
    const [applyDateToShow, setapplyDateToShow] = useState()
    const [lenderId, setlenderId] = useState('')
    const [filter, setFilter] = useState({
        lenderId: '',
        licenseId: '',
        type: ''
    })
    const [allStatus, setAllStatus] = useState([])
    const [status, setStatus] = useState('')
    useEffect(() => {
        console.log(communityId, "     comm");
        getAllDataHandler(pageNumber, noOfRows)
        getUserApi()

        getAllLenderHandler()
        getAllStatusApi()
        if (window.location.href.includes("/lender")) {
            getLenderEmpApi()
        }
    }, [])

    const leadTypeHandler = (data) => {

        setLeadType(data.target.value)
        let builderId = "";
        console.log(window.sessionStorage.getItem("userBuilderId"), "window.sessionStorage.getItem");
        if (qrId) {
            builderId = qrId
        } else if (window.sessionStorage.getItem("userBuilderId")) {
            builderId = window.sessionStorage.getItem("userBuilderId")
        }
        LenderGetAllLeadsApi(pageNumber, noOfRows, '', '', data.target.value, '', '', lenderId, status,
            communityId ? communityId : '', builderId ? builderId : '',
            callBack => {
                setAllData(callBack)
                setLoaderState(false)
                getCountHandler()
            },
            error => {

            })
    }
    const loanTypeHandler = (data) => {
        setloanType(data.target.value)
        // if (data.target.value === '') {
        LenderGetAllLeadsApi(pageNumber, noOfRows, '', '', leadType, applyDate, data.target.value, lenderId, status,
            communityId ? communityId : '', qrId ? qrId : '',
            callBack => {
                setAllData(callBack)
                setLoaderState(false)
                getCountHandler()
            },
            error => {

            })

        // }
    }
    const lenderHandler = (data) => {
        setlenderId(data.target.value)
        // if (data.target.value === '') {
        let builderId = "";
        console.log(window.sessionStorage.getItem("userBuilderId"), "window.sessionStorage.getItem");
        if (qrId) {
            builderId = qrId
        } else if (window.sessionStorage.getItem("userBuilderId")) {
            builderId = window.sessionStorage.getItem("userBuilderId")
        }
        LenderGetAllLeadsApi(pageNumber, noOfRows, '', '', leadType, applyDate, loanType, data.target.value, status,
            communityId ? communityId : '', builderId ? builderId : '',
            callBack => {
                setAllData(callBack)
                setLoaderState(false)
                getCountHandler()
            },
            error => {

            })

        // }
    }
    const statusHandler = (data) => {
        setStatus(data.target.value)
        // if (data.target.value === '') {
        let builderId = "";
        console.log(window.sessionStorage.getItem("userBuilderId"), "window.sessionStorage.getItem");
        if (qrId) {
            builderId = qrId
        } else if (window.sessionStorage.getItem("userBuilderId")) {
            builderId = window.sessionStorage.getItem("userBuilderId")
        }
        LenderGetAllLeadsApi(pageNumber, noOfRows, '', '', leadType, applyDate, loanType, lenderId, data.target.value,
            communityId ? communityId : '', builderId ? builderId : '',
            callBack => {
                setAllData(callBack)
                setLoaderState(false)
                getCountHandler()
            },
            error => {

            })

        // }
    }


    const getAllDataHandler = (page, rows) => {
        setLoaderState(true)
        let builderId = "";
        console.log(window.sessionStorage.getItem("userBuilderId"), "window.sessionStorage.getItem");
        if (qrId) {
            builderId = qrId
        } else if (window.sessionStorage.getItem("userBuilderId")) {
            builderId = window.sessionStorage.getItem("userBuilderId")
        }
        LenderGetAllLeadsApi(page, rows, '', '', leadType, '', '', lenderId, status,
            communityId ? communityId : '', builderId ? builderId : '',
            callBack => {
                setAllData(callBack)

                setLoaderState(false)
                getCountHandler()
            },
            error => {

            })
    }

    const getCountHandler = () => {
        LenderGetAllLeadsCountApi(emailId, phoneNo, leadType, loanType, applyDate,
            communityId ? communityId : '', qrId && !qrId === NaN ? qrId : '', callBack => {
                setTotalCount(callBack)
                setAllowedTotalClicks(Math.round(callBack / 100))
            }, error => {

            })
    }

    const searchChange = (e, type) => {
        if (type === 'phone') {
            setPhoneNo(e.target.value)
            if (e.target.value === '') {
                let builderId = "";
                console.log(window.sessionStorage.getItem("userBuilderId"), "window.sessionStorage.getItem");
                if (qrId) {
                    builderId = qrId
                } else if (window.sessionStorage.getItem("userBuilderId")) {
                    builderId = window.sessionStorage.getItem("userBuilderId")
                }
                LenderGetAllLeadsApi(1, 10, '', '', leadType, '', '', lenderId, status,
                    communityId ? communityId : '', builderId ? builderId : '',
                    callBack => {
                        setAllData(callBack)
                        setLoaderState(false)
                        getCountHandler()
                    },
                    error => {

                    })
            }
        }
        if (type === 'email') {
            setemailId(e.target.value)
            setPhoneNo('')
            setapplyDate('')
            if (e.target.value === '') {
                let builderId = "";
                console.log(window.sessionStorage.getItem("userBuilderId"), "window.sessionStorage.getItem");
                if (qrId) {
                    builderId = qrId
                } else if (window.sessionStorage.getItem("userBuilderId")) {
                    builderId = window.sessionStorage.getItem("userBuilderId")
                }
                LenderGetAllLeadsApi(1, 10, '', '', leadType, '', '', lenderId, status,
                    communityId ? communityId : '', builderId ? builderId : '',
                    callBack => {
                        setAllData(callBack)
                        setLoaderState(false)
                        getCountHandler()
                    },
                    error => {

                    })
            }
        }
        if (type === 'applyDate') {
            console.log(e.target.value)
            setapplyDateToShow(e.target.value)
            if (e) {
                setapplyDate(moment(e.target.value).format("DD-MM-YYYY"))
            } else {
                setapplyDate('')
                e = ''
            }
            let builderId = "";
            console.log(window.sessionStorage.getItem("userBuilderId"), "window.sessionStorage.getItem");
            if (qrId) {
                builderId = qrId
            } else if (window.sessionStorage.getItem("userBuilderId")) {
                builderId = window.sessionStorage.getItem("userBuilderId")
            }
            if (e === '') {
                LenderGetAllLeadsApi(1, 10, '', '', '', leadType, '', '', lenderId, status,
                    communityId ? communityId : '', builderId ? builderId : '',
                    callBack => {
                        setAllData(callBack)
                        setLoaderState(false)
                        getCountHandler()
                    },
                    error => {

                    })
            }
        }
        if (type === 'loanType') {
            console.log(e.target.va, 'lkijhgfghj')
            setloanType(e.target.value)
            let builderId = "";
            console.log(window.sessionStorage.getItem("userBuilderId"), "window.sessionStorage.getItem");
            if (qrId) {
                builderId = qrId
            } else if (window.sessionStorage.getItem("userBuilderId")) {
                builderId = window.sessionStorage.getItem("userBuilderId")
            }
            if (e === '') {
                LenderGetAllLeadsApi(1, 10, '', '', '', leadType, '', '', lenderId, status,
                    communityId ? communityId : '', builderId ? builderId : '',
                    callBack => {
                        setAllData(callBack)
                        setLoaderState(false)
                        getCountHandler()
                    },
                    error => {

                    })
            }
        }
    }

    const actionHandler = (type, data) => {
        if (type === 'edit') {
            const obj ={
                rowData: data,
                 communityId: communityId,
                  qrId: qrId 
            }
            handlePage(obj,"addcommunityLeadMain")
            // navigate(Routes.ADD_PERSONAL_LEADS, { state: { rowData: data, communityId: communityId, qrId: qrId } })

            // } else if (type === 'delete') {
            //     setIdForDelete(data)
            //     setDeletePopupState(true)
        // } else if (type === 'add') {
        //     navigate(Routes.LENDER_ADD_LEAD_PERSONAL)
        // } else if (type === 'communication') {
        //     if (window.location.href.includes('/admin')) {
        //         const rowData = {
        //             senderType: 'licence',
        //             id: LICENCE_ID
        //         }
        //         navigate(Routes.ADMIN_BULK_COMMUNICATION, { state: { rowData: rowData } })

        //     } else {
        //         const rowData = {
        //             senderType: 'LENDER',
        //             id: window.sessionStorage.getItem('lenderId')
        //         }
        //         navigate(Routes.LENDER_BULK_COMMUNICATION, { state: { rowData: rowData } })
        //     }
        } else if (type === 'delete' ) {
            setUserIdToDelete(data.userId)
            setLoanIdToDelete(data.loanId)
            setDeleteLeadPopupState(true)
        }
        if (type === 'search') {
            if (phoneNo !== '' || emailId !== '' || leadType !== '' || applyDate !== '' || loanType != '') {
                setLoaderState(true)
                let builderId = "";
                console.log(window.sessionStorage.getItem("userBuilderId"), "window.sessionStorage.getItem");
                if (qrId) {
                    builderId = qrId
                } else if (window.sessionStorage.getItem("userBuilderId")) {
                    builderId = window.sessionStorage.getItem("userBuilderId")  /*builderId??*/
                }
                LenderGetAllLeadsApi(1, 10, phoneNo, emailId, leadType, applyDate !== 'Invalid date' ? applyDate : '',
                    loanType, lenderId, status, communityId ? communityId : '', builderId ? builderId : '',
                    callBack => {
                        setAllData(callBack)
                        setLoaderState(false)
                        getCountHandler()
                    },
                    error => {

                    })
            }
        }
        if (type === 'view') {
            setData(data)
            setViewPopupState(true)
        }
        if (type === 'close') {
            setViewPopupState(false)
        }
    }

    const deleteHandler = (e) => {
        if (e === 'yes') {
            // deleteCommunityApi(idForDelete,
            //     callBack => {
            //         if (callBack === 'success') {
            //             getAllDataHandler(pageNumber, noOfRows)
            //         }
            //     }, error => {

            //     })
        } else {

        }
        setDeletePopupState(false)
    }

    const paginationHandler = (pageNo, rows) => {
        setPageNumber(pageNo)
        setNoOfRows(rows)
        getAllDataHandler(pageNo, rows)
    }

    const DetailHandler = (data, comment) => {
        if (comment === "comment") {
            // if (location.pathname === Routes.SUPER_ADMIN_ALL_LEADS) {
            //     navigate(Routes.SUPER_ADMIN_LEAD_DETAIL, { state: { rowData: data, cameFrom: 'comment' } })
            // } else if (location.pathname === Routes.LENDER_ALL_LEADS) {
            //     navigate(Routes.LENDER_LEAD_DETAIL, { state: { rowData: data, cameFrom: 'comment' } })
            // }
        } else {
            // if (location.pathname === Routes.SUPER_ADMIN_ALL_LEADS) {
            //     navigate(Routes.SUPER_ADMIN_LEAD_DETAIL, { state: { rowData: data } })
            // } else if (location.pathname === Routes.LENDER_ALL_LEADS) {
            //     navigate(Routes.LENDER_LEAD_DETAIL, { state: { rowData: data } })
            // }
            // else if (location.pathname === Routes.SUPER_ADMIN_COMMUNITY_DETAIL_PAGE) {
            //     navigate(Routes.SUPER_ADMIN_LEAD_DETAIL, { state: { rowData: data, communityId: communityId } })
            // }
            // else if (location.pathname === Routes.SUPER_ADMIN_QR_DETAILS) {
            //     navigate(Routes.SUPER_ADMIN_LEAD_DETAIL, { state: { rowData: data, qrId: qrId } })
            // }

            // if (location.pathname === Routes.SUPER_ADMIN_COMMUNITY_DETAIL_PAGE) {
            //     navigate(Routes.SUPER_ADMIN_LEAD_DETAIL, { state: { rowData: data, communityId: communityId } })
            // }

            leadPageHandler("LeadDetails",{ rowData: data, qrId: qrId })
        }
    }

    const commentHandler = (e, type, data) => {
        if (type === "input") {
            setComment(e.target.value)
            setCommentId(data)
            setcommentValueToShow(e.target.value + ',' + data)

        } else if (type === 'button') {
            if (commentId === data.loanId) {
                setLoaderState(true)
                comment ? SaveLenderComments(data, comment, callBack => {
                    setComment("")
                    setalertPopup(true)
                    setmsg('Comment Saved!')
                    removePopup()
                    setcommentValueToShow('' + ',' + data)
                },
                    error => {
                        setalertPopup(true)
                        setmsg('Something went wrong!')
                        removePopup()
                    }) : console.log("", "Null value");
                setLoaderState(false)
            }

        }
    }
    const openAssignmentPopup = (type, data, selectData) => {
        setLoanId(data)
        console.log(selectData, "   selectData selectData  ");
        if (type === 'open') {
            let lenderIds = []
            if (selectData) {
                selectData.map((data, i) => {
                    return (
                        lenderIds.push(data.lenderId)
                    )
                })
                setlenderIdList(lenderIds)
            }
            setassignmentPopup(true)
        }
        if (type === 'close') {
            setassignmentPopup(false)

        }
    }
    const openAssignmentPopupEmp = (type, data) => {
        setLoanId(data)
        if (type === 'open') {
            setEmpAssignPopup(true)
        }
        if (type === 'close') {
            setEmpAssignPopup(false)

        }
    }
    const openAssignmentPopupEmpLender = (type, data) => {
        setLoanId(data)
        if (type === 'open') {
            setLenderEmpAssignPopup(true)
        }
        if (type === 'close') {
            setLenderEmpAssignPopup(false)

        }
    }
    const getAllLenderHandler = () => {
        const search = { emailId: '', mobileNumber: '' }
        getLendersCountApi(search, count => {
            getLenderApi(1, count, search,
                callBack => {
                    let lenderData = []
                    callBack.forEach(x => {
                        lenderData.push({ name: x.lenderName, code: x.lenderId })
                    })
                    setAllLenders(lenderData)
                },
                error => {

                })
        }, error => {

        })
    }

    const getUserApi = () => {
        const search = { emailId: '', mobileNo: '' }
        getUserCountApi(search, count => {
            getUsersApi(1, count, search, callBack => {
                let emp = []
                callBack.forEach(x => {
                    emp.push({ name: x.name, code: x.adminId })
                })
                setEmpData(emp)
            }, error => {

            })
        }, error => {

        })
    }

    const getLenderEmpApi = () => {
        getLenderEmployee(callBack => {
            let emp = []
            if (callBack && callBack.data) {
                callBack.data.forEach(x => {
                    emp.push({ name: x.name, code: x.employeeId })
                })
            }
            setLenderEmpdata(emp)
        }, error => {

        })

    }

    const lenderChangeHadler = (e) => {
        console.log(e, "wuhu");
        setlenderIdList(e)
    }
    const empChangeHadler = (e) => {
        setEmpId(e.target.value)
    }
    const empLenderChangeHadler = (e) => {
        setLenderEmpId(e.target.value)
    }
    const submitLenderAssignment = () => {
        setLoaderState(true)
        let listOfLenders = []
        if (lenderIdList && loanId) {
            lenderIdList.map((data, i) => {
                let singleData = {
                    loanId: loanId,
                    lenderId: lenderIdList[i],
                    employeeId: window.sessionStorage.getItem('adminId')
                }
                listOfLenders.push(singleData)
            })
            assignMultipleLenders(listOfLenders, callBack => {
                if (callBack && callBack.message === 'success') {
                    setLoaderState(false)
                    setassignmentPopup(false)
                    setalertPopup(true)
                    setmsg('Successfully Assigned!')
                    removePopup()
                    getAllDataHandler(pageNumber, noOfRows)
                } else {
                    setLoaderState(false)
                    setalertPopup(true)
                    setmsg('Try agian later!')
                    removePopup()
                    getAllDataHandler(pageNumber, noOfRows)
                }
            })
        }
    }
    // ASSIGN_EMPLOYEE_LOAN assignEmployee
    const assignEmployeeLead = () => {
        setLoaderState(true)
        if (empId && loanId) {
            assignEmployee(empId, loanId, callBack => {
                if (callBack && callBack.message === 'success') {
                    setLoaderState(false)
                    setEmpAssignPopup(false)
                    setalertPopup(true)
                    setmsg('Successfully Assigned!')

                    removePopup()
                    getAllDataHandler(pageNumber, noOfRows)

                } else {
                    setLoaderState(false)
                    setalertPopup(true)
                    setmsg('Try agian later!')
                    removePopup()
                    getAllDataHandler(pageNumber, noOfRows)

                }
            })
        }
    }

    const assignEmployeeLeadLender = () => {
        setLoaderState(true)
        if (lenderEmpId && loanId) {
            assignLenderEmployee(lenderEmpId, loanId, callBack => {
                if (callBack && callBack.message === 'success') {
                    setLoaderState(false)
                    setLenderEmpAssignPopup(false)
                    setalertPopup(true)
                    setmsg('Successfully Assigned!')

                    removePopup()
                    getAllDataHandler(pageNumber, noOfRows)

                } else {
                    setLoaderState(false)
                    setalertPopup(true)
                    setmsg('Try agian later!')
                    removePopup()
                    getAllDataHandler(pageNumber, noOfRows)

                }
            })
        }
        setLoaderState(false)
    }


    const removePopup = () => {
        setTimeout(
            function () {
                setalertPopup(false)
            }.bind(this),
            5000
        );
    }

    const sortinghandler = (e) => {
        sortingFunction(allData, 'name', trigger, callBack => {
            setAllData(callBack.data)
            setTrigger(callBack.trigger === true ? false : true)
            forceUpdate()

        })
    }
    const paginationHandlerNew = (type, pageNumber) => {
        paginationFuction(type, pageNumber, totalCount, callBack => {
            console.log(callBack, 'callback')
            setPageNumber(callBack)
            getAllDataHandler(callBack, noOfRows)
        })
    }
    const searchHandler = (e) => {
        setSearch(e.target.value)

    }
    const getAllStatusApi = () => {
        getWorkflowApi(1, 100, filter,
            callBack => {
                if (callBack.length > 0) {
                    let arr = []
                    callBack.forEach(element => {

                        // if (element.currentStageName === "Approved" && rolesData && rolesData.includes('setStatusApproved')) {
                        //     arr.push({ code: element.currentStage, name: element.currentStageName })
                        // }
                        // if (element.currentStageName === "Disbursed" && rolesData && rolesData.includes('setStatusDisbursed')) {
                        //     arr.push({ code: element.currentStage, name: element.currentStageName })
                        // }
                        // if (element.currentStageName === "Paid" && rolesData && rolesData.includes('setStatusPaid')) {
                        //     arr.push({ code: element.currentStage, name: element.currentStageName })
                        // }
                        if (element.currentStageName === "Approved" ) {
                            arr.push({ code: element.currentStage, name: element.currentStageName })
                        }
                        if (element.currentStageName === "Disbursed" ) {
                            arr.push({ code: element.currentStage, name: element.currentStageName })
                        }
                        if (element.currentStageName === "Paid" ) {
                            arr.push({ code: element.currentStage, name: element.currentStageName })
                        }
                        if (element.currentStageName !== "Paid" && element.currentStageName !== "Disbursed" && element.currentStageName !== "Approved") {
                            arr.push({ code: element.currentStage, name: element.currentStageName })
                        }

                    });
                    setAllStatus(arr)
                    Object.values(arr).map((data, i) => {
                        if (data.name === location.state.rowData.loanStatus) {
                            setStatus(data.code)
                        }
                    })


                }
            },
            error => {

            })
    }

    const customDeletePopupHandler = (e) => {
        if (e === 'yes') {
            setLoaderState(true)
            setUserIdToDelete(undefined)
            deleteLeadAdmin(userIdToDelete, loanIdToDelete, callBack => {
                if (callBack === "success") {
                    setLoaderState(false)
                    setDeleteLeadPopupState(false)
                    setUserIdToDelete('')
                    setLoanIdToDelete('')
                    getAllDataHandler(pageNumber, noOfRows)
                } else {
                    setDeleteLeadPopupState(false)
                    setmsg("Something Went Wrong!!")
                    setalertPopup(true)
                    removePopup()
                }
                setLoaderState(false)
            }, error => {
                setLoaderState(false)
            })
        } else if (e === 'no') {
            setLoaderState(false)
            setDeleteLeadPopupState(false)
            setUserIdToDelete('')
            setLoanIdToDelete('')
        }

    }
    return (
        <div className='container-fluid'>
            {alertPopup ?
                <Alerts msg={msg} />
                : ""}
            {assignmentPopup ?
                <AssigmentUi
                    openAssignmentPopup={openAssignmentPopup}
                    lenderData={lenderData}
                    lenderChangeHadler={lenderChangeHadler}
                    submitLenderAssignment={submitLenderAssignment}
                    value={lenderIdList}
                />
                : ""}
            {deletePopupState ?
                <DeletePopup deleteHandler={deleteHandler} />
                : null}
            {
                deleteLeadPopupState ? <CustomDeletePopup deleteHandler={customDeletePopupHandler} message={
                    "Are you sure you want to delete this lead? \n You won't be able to recover it again."
                } /> : ''
            }
            {viewPopupState ? <ViewLeadsInfoPopup data={data} actionhandler={actionHandler} /> : ""}
            {
                empAssignPopup ? <EmpAssignmentPopup
                    empdata={empData}
                    openAssignmentPopup={openAssignmentPopupEmp}
                    empChangeHandler={empChangeHadler}
                    submitEmpAssignment={assignEmployeeLead} /> : ""
            }
            {
                lenderEmpAssignPopup ? <EmpAssignmentPopup
                    empdata={lenderEmpData}
                    openAssignmentPopup={openAssignmentPopupEmpLender}
                    empChangeHandler={empLenderChangeHadler}
                    submitEmpAssignment={assignEmployeeLeadLender} /> : ""
            }
            {
                loaderState ?
                    <Loader />
                    :
                    <>
                        <div className='mb-3 mt-5 row'>
                            <div className='col-sm-1 col-xs-12'>
                                {/* {rolesData && rolesData.includes("bulkCommunication") ?
                                        <button
                                            className='cred-btn center-block'
                                            onClick={e => actionHandler('communication')}
                                        >Bulk &nbsp;&nbsp;<i className='fa fa-commenting' /></button>
                                        : ""} */}
                            </div>
                            <div className='col-sm-7 col-xs-12'>
                            </div>

                            {/* <div className='col-sm-2 col-xs-12'>
                                {
                                    window.location.href.includes('admin') ?
                                        <FormControl size='small' variant="outlined" style={{ width: '100%' }}>
                                            <InputLabel id="leadType">Lead Type</InputLabel>
                                            <Select
                                                labelId="leadType"
                                                id="leadType"
                                                value={leadType}
                                                onChange={e => leadTypeHandler(e)}
                                                label="Lead Type"
                                            >
                                                <MenuItem value="">
                                                    <em>Select Value</em>
                                                </MenuItem>
                                                {filterData.map((data, i) => {
                                                    return (
                                                        <MenuItem value={data.code}>{data.name}</MenuItem>
                                                    )
                                                })}

                                            </Select>
                                        </FormControl>
                                        : ""}
                            </div>
                            <div className='col-xs-12 col-sm-2'>
                                <FormControl size='small' variant="outlined" style={{ width: '100%' }}>
                                    <InputLabel id="demo-simple-select-standard-label">Loan Type</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard"
                                        value={loanType}
                                        // onChange={e => searchChange(e, 'loanType')}
                                        onChange={(e) => loanTypeHandler(e)}
                                        label="Loan Type">

                                        <MenuItem value="">
                                            <em>Select Value</em>
                                        </MenuItem>
                                        {completeLoanTypeArr.map((data, i) => {
                                            return (
                                                <MenuItem value={data.code}>{data.name}</MenuItem>
                                            )
                                        })}

                                    </Select>
                                </FormControl>
                            </div> */}
                        </div>
                        <div className=' full-height'>
                            <div className='row full-height'>
                                <div className=' mb-3 col-sm-10' style={{display:'flex'}}>
                                    <div className=''>

                                        <select className='slectsearch' value={search} onChange={(e) => searchHandler(e)}>

                                            <option value='mobile'>By Mobile</option>
                                            <option value='email'> By Email</option>
                                            <option value='date'> By Date</option>


                                        </select>
                                    </div>
                                    <div className=''>
                                        {search === 'email' ?
                                            <input value={emailId} className='slectinput' placeholder={search} onChange={e => searchChange(e, 'email')} />
                                            : ""}
                                        {search === 'mobile' ?
                                            <input value={phoneNo} className='slectinput' type='number' placeholder={search} onChange={e => searchChange(e, 'phone')} />

                                            : ""}
                                        {console.log(applyDate, 'applyDate')}
                                        {search === 'date' ?
                                            <input
                                                value={applyDateToShow}
                                                data-date-format="DD MMMM YYYY"
                                                className='slectinput' type='date' placeholder={search} onChange={e => searchChange(e, 'applyDate')} />
                                            : ""}
                                    </div>
                                    &nbsp;&nbsp;&nbsp;
                                    <div className='btn-group' >
                                        <button
                                            className='cred-btn center-block mr-3'
                                            onClick={e => actionHandler('search')}
                                            style={{padding:'12px 15px',background:'rgb(12, 57, 83)'}}
                                        ><i className='fa fa-search' style={{fontSize:'20px'}}/></button>

                                    </div>
                                </div>

                                {/* <div className='col-xs-12 col-sm-2'>
                                    {window.location.href.includes('/admin') ?
                                        <FormControl size='small' variant="outlined" style={{ width: '100%' }}>
                                            <InputLabel id="demo-simple-select-standard-labels">Lender</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-standard-labels"
                                                id="demo-simple-select-standard"
                                                value={lenderId}
                                                // onChange={e => searchChange(e, 'loanType')}
                                                onChange={(e) => lenderHandler(e)}
                                                label="Select Lender">

                                                <MenuItem value="">
                                                    <em>Select Value</em>
                                                </MenuItem>
                                                {lenderData ? lenderData.map((data, i) => {
                                                    return (
                                                        <MenuItem value={data.code}>{data.name}</MenuItem>
                                                    )
                                                }) : ""}

                                            </Select>
                                        </FormControl>
                                        : ""}
                                </div> */}

                                <div className='col-xs-12 col-sm-2'>
                                    <FormControl size='small' variant="outlined" style={{ width: '100%' }}>
                                        <InputLabel id="demo-simple-select-standard-status">Status </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-standard-status"
                                            id="demo-simple-select-standard-status"
                                            value={status}
                                            // onChange={e => searchChange(e, 'loanType')}
                                            onChange={(e) => statusHandler(e)}
                                            label="Loan Type"
                                        >

                                            <MenuItem value="">
                                                <em>Select Value</em>
                                            </MenuItem>
                                            {allStatus && allStatus.map((data, i) => {
                                                return (
                                                    <MenuItem value={data.code}>{data.name}</MenuItem>
                                                )
                                            })}

                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            {/* <div className='mb-3 mt-3 row'>
                                <div className='col-sm-1 col-xs-12'>
                                    {rolesData && rolesData.includes("bulkCommunication") ?
                                        <button
                                            className='cred-btn center-block'
                                            onClick={e => actionHandler('communication')}
                                        >Bulk &nbsp;&nbsp;<i className='fa fa-commenting' /></button>
                                        : ""}
                                </div>
                                <div className='col-sm-7 col-xs-12'>
                                </div>
                                {
                                    window.location.href.includes('admin') ?
                                        <div className='col-sm-2 col-xs-12'>

                                            <FormControl size='small' variant="outlined" style={{ width: '100%' }}>
                                                <InputLabel id="leadType">Lead Type</InputLabel>
                                                <Select
                                                    labelId="leadType"
                                                    id="leadType"
                                                    value={leadType}
                                                    onChange={e => leadTypeHandler(e)}
                                                    label="Lead Type"
                                                >
                                                    <MenuItem value="">
                                                        <em>Select Value</em>
                                                    </MenuItem>
                                                    {filterData.map((data, i) => {
                                                        return (
                                                            <MenuItem value={data.code}>{data.name}</MenuItem>
                                                        )
                                                    })}

                                                </Select>
                                            </FormControl>
                                        </div>
                                        : ""}


                                <div className='col-xs-12 col-sm-2'>
                                    <FormControl size='small' variant="outlined" style={{ width: '100%' }}>
                                        <InputLabel id="demo-simple-select-standard-label">Loan Type</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            value={loanType}
                                            // onChange={e => searchChange(e, 'loanType')}
                                            onChange={(e) => loanTypeHandler(e)}
                                            label="Loan Type">

                                            <MenuItem value="">
                                                <em>Select Value</em>
                                            </MenuItem>
                                            {completeLoanTypeArr.map((data, i) => {
                                                return (
                                                    <MenuItem value={data.code}>{data.name}</MenuItem>
                                                )
                                            })}

                                        </Select>
                                    </FormControl>
                                </div>
                            </div> */}
                            {/* <div class1Name='col-sm-2 col-xs-12'>

                                <FormControl fullWidth>

                                    <TextField
                                        label='Search Email Id'
                                        type='search'
                                        variant='outlined'
                                        value={emailId}
                                        name={'emailId'}
                                        id={'emailId'}
                                        onChange={e => searchChange(e, 'email')}
                                        size='small'


                                    />
                                </FormControl>
                            </div>
                            <div className='col-sm-2 col-xs-12'>
                                <FormControl fullWidth>

                                    <TextField
                                        label="Search Mobile No"
                                        variant="outlined"
                                        value={phoneNo}
                                        name="mobileNo"
                                        id="mobileNo"
                                        type="number"
                                        onChange={e => searchChange(e, 'phone')}
                                        size="small"


                                    />
                                </FormControl>

                            </div> */}
                            {/* {
                                window.location.href.includes('admin') ?
                                    <div className='col-sm-2 col-xs-12'>
                                     
                                        <FormControl size='small' variant="outlined" style={{ width: '100%' }}>
                                            <InputLabel id="leadType">Lead Type</InputLabel>
                                            <Select
                                                labelId="leadType"
                                                id="leadType"
                                                value={leadType}
                                                onChange={e => leadTypeHandler(e)}
                                                label="Lead Type"
                                            >
                                                <MenuItem value="">
                                                    <em>Select Value</em>
                                                </MenuItem>
                                                {filterData.map((data, i) => {
                                                    return (
                                                        <MenuItem value={data.code}>{data.name}</MenuItem>
                                                    )
                                                })}

                                            </Select>
                                        </FormControl>
                                    </div>
                                    : ""}


                            <div className='col-xs-12 col-sm-2'>
                                <FormControl size='small' variant="outlined" style={{ width: '100%' }}>
                                    <InputLabel id="demo-simple-select-standard-label">Loan Type</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard"
                                        value={loanType}
                                        onChange={e => searchChange(e, 'loanType')}
                                        label="Loan Type"
                                    >
                                        <MenuItem value="">
                                            <em>Select Value</em>
                                        </MenuItem>
                                        {completeLoanTypeArr.map((data, i) => {
                                            return (
                                                <MenuItem value={data.code}>{data.name}</MenuItem>
                                            )
                                        })}

                                    </Select>
                                </FormControl> */}
                            {/* <SelectField
                                    label={'Loan Type'}
                                    onChange={e => searchChange(e, 'loanType')}
                                    id="loanType"
                                    value={loanType}
                                    name="loanType"
                                    data={completeLoanTypeArr}
                                    size={'small'}
                                    required={true}
                                /> */}
                            {/* </div> */}
                            {/* <div className='col-xs-12 col-sm-2'> */}
                            {/* {console.log('applyDate ', applyDate)} */}
                            {/* <DatePicker
                                    label="Apply Date"
                                    // format={'MM/dd/yyyy'}
                                    variant='outlined'
                                    value={(applyDate != null && applyDate != '') ? moment(applyDate).format("DD/MM/YYYY") : ""}
                                    name="applyDate"
                                    size="small"
                                    onChange={(e) => searchChange(e, 'applyDate')}
                                    required={false}
                                /> */}
                            {/* </div> */}

                            {/* <div className='col-sm-2 col-xs-12'>
                                <div className='btn-group' style={{ marginTop: '2px' }}>
                                    <button
                                        className='cred-btn center-block mr-3'
                                        onClick={e => actionHandler('search')}
                                    ><i className='fa fa-search' /></button>
                                    {rolesData && rolesData.includes("bulkCommunication") ?
                                        <button
                                            className='cred-btn center-block'
                                            onClick={e => actionHandler('communication')}
                                        >Bulk &nbsp;&nbsp;<i className='fa fa-commenting' /></button>
                                        : ""}
                                </div>

                            </div> */}

                            {/* {
                                rolesData && rolesData.includes("bulkCommunication") ?
                                    <div className='col-sm-12 col-md-4'>
                                        <div className='btn-group'>
                                         
                                            {location.pathname === Routes.LENDER_ALL_LEADS ?
                                                <button
                                                    className='cred-btn center-block'
                                                    onClick={e => actionHandler('communication')}
                                                >Bulk &nbsp;&nbsp;<i className='fa fa-commenting' /></button>
                                                : null}
                                        </div>
                                    </div>
                                    : ""} */}
                            <div className='row' style={{marginTop:'30px'}}>
                                <div className='col-sm-12 '>
                                    <Table
                                        disable={disable}
                                        paginationHandlerNew={paginationHandlerNew}
                                        sortinghandler={sortinghandler}
                                        commentValueToShow={commentValueToShow}
                                        openAssignmentPopup={openAssignmentPopup}
                                        actionHandler={actionHandler}
                                        allData={allData}
                                        DetailHandler={DetailHandler}
                                        totalCount={totalCount}
                                        pageNumber={pageNumber}
                                        paginationHandler={paginationHandler}
                                        noOfRows={noOfRows}
                                        commentHandler={commentHandler}
                                        openEmpAssignmentPopup={openAssignmentPopupEmp}
                                        openEmpAssignmentPopupLender={openAssignmentPopupEmpLender}
                                        lenderEmpData={lenderEmpData}
                                        empData={empData}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* </div> */}
                    </>
            }
        </div>
    )
}

export default UiComponent;